"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ILFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_109)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_109`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.9018 8.58949H13.9649L12 5.17896L10.0351 8.58949H6.09825L8.06316 12L6.09825 15.4105H10.0351L12 18.8211L13.9649 15.4105H17.9018L15.9368 12L17.9018 8.58949ZM14.5754 12L13.3684 14.3298H10.6386L9.42456 12L10.6316 9.67019H13.3614L14.5754 12ZM12 6.96142L12.8351 8.59651H11.1579L12 6.96142ZM7.90877 9.67019H9.58597L8.82807 11.1439L7.90877 9.67019ZM7.90877 14.3298L8.82105 12.779L9.65614 14.3298H7.90877ZM12 16.9614L11.1649 15.4105H12.8421L12 16.9614ZM16.1684 14.3298H14.414L15.2491 12.779L16.1684 14.3298ZM14.3368 9.67019H16.1684L15.2561 11.2211L14.3368 9.67019ZM-6 1.49475H29.9298V4.49124H-6V1.49475ZM-6 19.4597H29.9298V22.4562H-6V19.4597Z",
					fill: "#2E52B2"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_109`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ILFlag };
